export enum PrinterTypeStatusEnum {
    ZERO = 'Disabled',
    ONE = 'Available',
}
